export const CompareButton = {
  template:`
  <div class="compare-button">
  <div v-if="!selected" v-on:click="toggle"  class="add-to-compare-link cursor-pointer" href="">
  <input @click="addToCompare(vehicleId)" type="checkbox" name="checkbox" :id="'checkbox-'+vehicleId"  v-model="selected" />
  <label @click="addToCompare(vehicleId)" class="add-to-compare-label cursor-pointer" :for="'checkbox-'+vehicleId">{{title}}</label>
  </div>
  <div v-else class="add-to-compare-link" href="">
  <input @click="removeSelected(vehicleId)" type="checkbox" name="checkbox" :id="'checkbox-selected-'+vehicleId" v-model="selected" />
  <label @click="removeSelected(vehicleId)" class="add-to-compare-label cursor-pointer" :for="'checkbox-selected-'+vehicleId">{{titleSelected}}</label>
  </div>
  <div v-if="selected" class="w-full cursor-pointer go-to-compare-button text-white border-2 rounded px-2 border-solid bg-primary border-primary">
  <a @click.prevent="goToComparePage()">{{goToPage}}</a>
  </div>
  </div>
`,
  props: ['vehicleId', 'title', 'titleSelected', 'goToPage'],
  data(){
      return {
          selected: false,
      }
  },
  created: function () {
    if(!this.item){
      this.item =  '';
    }
    this.checkSelected();
  },
  methods:{
      toggle(){
          this.selected = !this.selected
      },
      addToCompare(id, lang) {
          //console.log(lang)
          let compare;
          if (!localStorage.compare) {
            var Obj = {
              ids: [id],
            };
            localStorage.setItem('compare', JSON.stringify(Obj));
          } else {
            compare = JSON.parse(localStorage.compare);
    
            if (compare.ids.indexOf(id) == -1) compare.ids.push(id);
    
            if (compare.ids.length > 4) {
              compare.ids.splice(0, 1);
            }
            localStorage.compare = JSON.stringify(compare);
          }
    
          compare = JSON.parse(localStorage.compare);
    
          let urlIds = [];
          var j = 0;
          for (var i = compare.ids.length - 1; i >= 0; i--) {
            if (j >= 4) break;
    
            urlIds.push(compare.ids[i]);
            j++;
          }
        },
        goToComparePage(lang){
          let compare = JSON.parse(localStorage.compare);
          let urlIds = [];
          var j = 0;
          for (var i = compare.ids.length - 1; i >= 0; i--) {
            if (j >= 4) break;
    
            urlIds.push(compare.ids[i]);
            j++;
          }
          var slug = '/compare/';
          if (lang == 'fr-CA') {
            slug = '/comparer/'
          }
          window.location.href = slug + '?vehicles=' + urlIds.join('|');
        },
        checkSelected(){
          let local = JSON.parse(window.localStorage.getItem('compare'));
        
          if(local !== null)
            for (var i = 0; i < 9; i++) {
              if (this.vehicleId == local.ids[i]){
                this.toggle();
              }
            }
        },
        removeSelected(id) {
          let local = JSON.parse(window.localStorage.getItem('compare'));
          if(local !== null)
            for (var i = 0; i < 9; i++) {
              if (id == local.ids[i]){
                local.ids.splice(i, 1);
              }
            }
          
          window.localStorage.removeItem('compare');
          localStorage.setItem('compare', JSON.stringify(local));
          this.toggle()
        },
        toggleSelected(id){
          if (this.selected){
            this.removeSelected(id);
            this.toggle();
          }
          else
            this.addToCompare(id);
        }
  }
}